






import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class SVGIcon extends Vue {
  @Prop({ default: "" }) readonly icon!: string;
  @Prop({ default: "" }) readonly viewBox!: string;
  @Prop({ default: "" }) readonly classes!: string;
}
